import { gql } from "@apollo/client";

export default gql`
  mutation setUpdateNotification($message: String){
    setUpdateNotification(message: $message){
        success
        data{
            updatedAt
            message
        }
        code
        message
    }
}
`
